import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSubContractor() {
    return (
        <div className="w-full h-full">
        <Outlet/>
        </div>
      )
    }
    
export default MainSubContractor